export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/send.d8c2dcda.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};